<div class="row component-card">
  <div class="col-12 col-md-7 left-card">
    <h1>
      <span class="strok-text">{{ data.title.split(" ")[0] }} </span
      >{{ data.title.split(" ").slice(1).join(" ") }}
    </h1>
    <h5 class="mb-4" [innerHTML]="data.content"></h5>
  </div>
  <div class="col-11 col-md-5 text-center m-auto">
    <img class="person-img" [src]="data.imgsrc" [alt]="data.name" />
    <h4 class="name">{{ data.name }}</h4>
  </div>
</div>
